import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    purchaseOrder: {
        data: [],
        currentPage: 1,
    },
    purchaseOrderRequest: {
        data: [],
        currentPage: 1,
    },
    purchaseOrdersDashboardData: [],
    totalItems: 0
};


const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setOrdersByType: (state, action) => {
            const { type, data, currentPage } = action.payload;

            state[type] = {
                ...state[type],
                data,
                currentPage,
            };
        },
        setPurchaseOrderDashboardData: (state, action) => {
            state.purchaseOrdersDashboardData = action.payload;
        },
        setTotalItems: (state, action) => {
            state.totalItems = action.payload;
        },
    },
});

export const { setOrdersByType, setPurchaseOrderDashboardData,setTotalItems } = orderSlice.actions;
export default orderSlice.reducer;